import { navigateToWorkflow, resolveWorkflowRefTarget } from "./navigateToWorkflow";

export function createWorkflowRefContextMenuExtension(filetreeStore) {
  return {
    createItemsProvider() {
      return {
        getItems(step, _sequence) {
          const items = [];
          const workflowId = resolveWorkflowRefTarget(step);

          if (workflowId) {
            items.push({
              label: "Go to Workflow",
              order: 10,
              callback: () => navigateToWorkflow(filetreeStore, workflowId),
            });
          }

          return items;
        },
      };
    },
  };
}
